import {
  NotificationBase,
  NotificationReadBatchUpdateItem,
  NotificationReadBatchUpdateResponse,
  NotificationTempMapping,
} from "../types/notification.types";
import { getTokenAsync } from "@coworker/app/src/hooks/API/getAuthToken";
import { makeHeaders } from "@coworker/app/src/components/RoomSettings/tools";
import { NOTIFICATIONS_SERVICE_URL } from "@coworker/app/src/hooks/API/notifications.service";
import { CORE_SERVICE_URL } from "@coworker/app/src/hooks/API/core.service";
import { FixaWindow } from "@coworker/reusable/helpers/devices";

function getBaseUrl(): string {
  const useNotificationsService = (window as FixaWindow)
    .useNotificationsService;
  const serviceUrl = useNotificationsService
    ? NOTIFICATIONS_SERVICE_URL
    : CORE_SERVICE_URL;
  return `${serviceUrl}/notifications`;
}

export function tempMapping(item: NotificationTempMapping) {
  const { type, content, props, ...rest } = item;
  if (!content || !content.type) {
    return {
      ...rest,
      content: { type, props },
      contentType: type,
    };
  } else {
    return item;
  }
}

export const setMessageNotificationAsRead = async (notificationId: string) => {
  const token = await getTokenAsync();
  if (!token || typeof token !== "string") {
    throw new Error("Could not get a token.");
  }
  const response = await fetch(
    `${getBaseUrl()}/messages/read/${encodeURIComponent(notificationId)}`,
    {
      method: "PUT",
      headers: makeHeaders(token),
      body: JSON.stringify({ read: true }),
    }
  );

  if (!response.ok) {
    throw new Error("Notifications: Network response was not ok.");
  }

  const json = (await response.json()) as NotificationTempMapping;
  return tempMapping(json) as NotificationBase;
};

export const setAllMessageNotificationAsRead = async (
  notificationIds: string[]
) => {
  const readAndIdList: NotificationReadBatchUpdateItem[] = notificationIds.map(
    (notificationId) => ({
      notificationId,
      read: true,
    })
  );

  const token = await getTokenAsync();
  if (!token || typeof token !== "string") {
    throw new Error("Notifications: Could not get a token.");
  }
  const response = await fetch(`${getBaseUrl()}/messages/read/batch`, {
    method: "PUT",
    headers: makeHeaders(token),
    body: JSON.stringify(readAndIdList),
  });

  if (!response.ok) {
    throw new Error("Notifications: Network response was not ok.");
  }

  const data = (await response.json()) as NotificationReadBatchUpdateResponse;
  data.updated.map((item) => {
    return item;
  });

  if (data.failed.length) {
    console.error(
      "Notifications: setAllMessageNotificationAsRead failed",
      JSON.stringify(data.failed)
    );
  }
  return data;
};
